import React, { useState, useEffect } from 'react'
import ChatBotIntegration from './component/addchatbot'
import SetupChatBot from './component/setupchatbot'
import GetShopifyURl from './component/shopify/getshopifyurl'
import GetWebsiteStore from './component/website/getwebsitestore'
import GetMagentoStore from './component/website/getmagentostore'
import useChatbotLoader from '../../util/chatbotloader'

const AddChatBot = () => {
  //   useChatbotLoader('', '')
  const [activeComponent, setActiveComponent] = useState(0)
  const handleAddChatBot = () => {
    setActiveComponent(1)
  }
  const handlebacktochatbot = () => {
    setActiveComponent(0)
  }
  const handlebacktosetupchatbot = () => {
    setActiveComponent(1)
  }
  const handleshopify = () => {
    localStorage.setItem('chatbot', 'shopify')
    setActiveComponent(2)
  }
  const handlewebsite = () => {
    localStorage.setItem('chatbot', 'website')
    setActiveComponent(3)
  }

  const handlemagento = () => {
    localStorage.setItem('chatbot', 'magento')
    setActiveComponent(4)
  }

  useEffect(() => {
    const handleGoHome = () => {
      handlebacktochatbot()
    }

    window.addEventListener('go-home', handleGoHome)

    return () => {
      window.removeEventListener('go-home', handleGoHome)
    }
  }, [])
  useEffect(() => {
    if (localStorage.getItem('onboarding')) {
      setActiveComponent(2)
    } else {
      setActiveComponent(0)
    }
  }, [])

  // useEffect(() => {
  //     const SyncData = async () => {
  //         console.log("hello");
  //       if (localStorage.getItem('onboarding')) {
  //         if (localStorage.getItem('store_id')) {
  //           try {
  //             const res = await DatasetSync(localStorage.getItem('store_id'));
  //             if (res.success) {
  //               navigate('/bot-customization');
  //             //   toast.success(res.message, {
  //             //     position: 'bottom-center',
  //             //   });
  //             }
  //           } catch (error) {
  //             console.error('Error syncing dataset:', error);
  //           }
  //         }
  //       } else {
  //         navigate('/training');
  //       }
  //     };

  //     SyncData();
  //   }, []);

  return (
    <div className='p-5'>
      <div className='block mt-2'>
        {activeComponent === 0 && (
          <ChatBotIntegration onAdd={handleAddChatBot} />
        )}
        {activeComponent === 1 && (
          <SetupChatBot
            handleback={handlebacktochatbot}
            handlewebsite={handlewebsite}
            handleshopify={handleshopify}
            handlemagento={handlemagento}
          />
        )}
        {activeComponent === 2 && (
          <div className='p-4'>
            <GetShopifyURl handleback={handlebacktosetupchatbot} />
          </div>
        )}
        {activeComponent === 3 && (
          <div className='p-4'>
            <GetWebsiteStore handleback={handlebacktosetupchatbot} />
          </div>
        )}
        {activeComponent === 4 && (
          <div className='p-4'>
            <GetMagentoStore handleback={handlebacktosetupchatbot} />
          </div>
        )}
      </div>
    </div>
  )
}

export default AddChatBot
